export function validatePhoneNumber(phone: string): string | null {
  const digits = phone.replace(/\D/g, ""); 

  if (digits.length === 0) return null;

  if (!/^[6-9]/.test(digits)) {
    return "Please enter a valid 10 digit mobile number";
  }

  if (digits.length < 10) return null;

  // final strict validation when length is 10
  if (!/^[6-9]\d{9}$/.test(digits)) {
    return "Please enter a valid 10-digit number starting with 6-9";
  }

  return null;
}

export function validateEmail(email: string): string | null {
  const value = email.trim();
  if (!value) return "Please enter your email address";
  if (value.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
    return "Please enter a valid email address";
  }
  return null;
}

export function sanitizePhoneInput(value: string): string {
  return value.replace(/\D/g, "");
}

export function validateName(name: string): string | null {
  if (name.trim().length === 0) return null; // No error when empty

  if (name.trim().length < 3) {
    return "Name must be at least 3 characters long";
  }

  return null;
}

export function containsHTMLOrScript(text: string): boolean {
  const htmlPattern = /<[^>]*>/g;
  const scriptPattern = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  return htmlPattern.test(text) || scriptPattern.test(text);
}

export function containsURL(text: string): boolean {
  const urlPattern = /(?:https?:\/\/|www\.)[^\s]+/gi;
  return urlPattern.test(text);
}

export function containsMaliciousContent(text: string): boolean {
  const maliciousPatterns = [
    /javascript:/gi,
    /on\w+\s*=/gi, // Event handlers like onclick=, onload=
    /data:text\/html/gi,
    /<iframe/gi,
    /<embed/gi,
    /<object/gi,
  ];
  return maliciousPatterns.some(pattern => pattern.test(text));
}

export function sanitizeTextInput(text: string): { isValid: boolean; error: string | null } {
  if (containsHTMLOrScript(text)) {
    return { isValid: false, error: "HTML tags and scripts are not allowed" };
  }
  if (containsURL(text)) {
    return { isValid: false, error: "URLs are not allowed" };
  }
  if (containsMaliciousContent(text)) {
    return { isValid: false, error: "Invalid characters or patterns detected" };
  }
  return { isValid: true, error: null };
}
